// import AvatarDropDown  from "@/components/custom/AvatarDropDown";
// import {  
//   Bell,
//   CircleUserRound } from "lucide-react";
import Icon from '@/img/logo_rm.svg';

import { useAuth } from "./auth";
import { useApiFetch } from './helper/apiFetch';
import { useAppHub } from './realtime/AppHubProvider';
import { useTranslate } from './helper/translate';
export function SiteHeader() {
  const { logout } = useAuth();
  const apiFetch = useApiFetch();
  const { isConnected: isHubConnected } = useAppHub();
  const { translate } = useTranslate();

  const Logout = async() => {

    const res = await apiFetch(`/admin/Logout`, {
        method: "GET"
       
        
      });

      if (!res.ok) {
        

      }
      else
      {
        logout();
      }

  
   
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-black text-white p-3">
      <div className="flex justify-between">
        <div>
          <img src={Icon} className="h-8"/>
        </div>
        {/* <div className="flex gap-3">
          <Bell color="white" fill="white" />
         
          <AvatarDropDown />
        </div> */}

         <div className="flex items-center gap-3">
          <span
            className={`inline-block h-2.5 w-2.5 rounded-full ${isHubConnected ? "bg-green-500" : "bg-red-500"}`}
            title={isHubConnected ? "Hub connected" : "Hub disconnected"}
            aria-label={isHubConnected ? "Hub connected" : "Hub disconnected"}
          />
          <div className="relative cursor-pointer" onClick={Logout}>{translate("auth.logout")}</div>
        </div>
      </div>
    </header>
  )
}